<template>
  <div class="main">
    <van-image fit="cover" :src="(isMobile && data[indexId].bannerMobile) ? data[indexId].bannerMobile : data[indexId].banner" class="banner" />
    <div v-for="(item, index) of nowData.componentList" :key="index">
      <!-- 方案介绍 -->
      <Introduce v-if="item.type == 'Introduce'" :title='data[indexId].title' :desc='item.desc' :descMobile='item.descMobile' :img='data[indexId].img'></Introduce>
      <Introduce2
        :title="item.title"
        v-if="item.type == 'Introduce2'"
        :desc="item.desc"
        :img="item.img"
        :img2="item.img2"
      ></Introduce2>
      <Introduce3
        :title="'方案介绍'"
        v-if="item.type == 'Introduce3'"
        :desc="item.desc"
        :img="item.img"
      ></Introduce3>
      <Position
        v-if="item.type == 'Position'"
        :title="item.title"
        :list="item.list"
      ></Position>
      <!-- 课程资源 -->
      <div class="component1" v-if="item.type == 'component1'" :style="{'backgroundColor': item.background}" :class="{'component1Three': item.list.length == 3}">
        <div>
          <div class="title">{{ item.title }}</div>
          <div class="content">
            <div class="list" v-for="itemSon of item.list" :key="itemSon.title">
              <div class="headline">{{ itemSon.title }}</div>
              <div class="desc">{{ itemSon.desc }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 课程介绍 -->
      <div class="component4" v-if="item.type == 'component4'">
        <div>
          <div class="title">{{ item.title }}</div>
          <div class="content">
            <div class="list" v-for="itemSon of item.list" :key="itemSon.title">
              <div class="headline">{{ itemSon.title }}</div>
              <div class="desc">{{ itemSon.desc }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 教学软件 -->
      <div class="component2" v-if="item.type == 'component2'">
        <div>
          <div class="title">{{ item.title }}</div>
          <div class="content">
            <div class="list" v-for="itemSon of item.list" :key="itemSon.title">
              <div class="headline">
                <img
                  src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/plan/55.png"
                  alt=""
                />
                <span>{{ itemSon.title }}</span>
              </div>
              <div class="desc">
                <div v-for="itemSun of itemSon.desc" :key="itemSun">
                  {{ itemSun }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 课件资源 -->
      <div class="component3" v-if="item.type == 'component3'">
        <div id="isPC">
          <div class="title">{{ item.title }}</div>
          <div class="content">
            <div
              class="list"
              v-for="(itemSon, index) of item.list"
              :key="index"
            >
              <div class="desc" v-for="itemSun of itemSon" :key="itemSun">
                {{ itemSun }}
              </div>
            </div>
          </div>
        </div>
        <div id="isMobile">
          <div class="title">{{ item.title }}</div>
          <div class="content">
            <div
              class="list"
              v-for="(itemSon, index) of item.list"
              :key="index"
            >
              <div class="desc" v-for="itemSun of itemSon" :key="itemSun">
                {{ itemSun }}
              </div>
            </div>
          </div>
        </div>
        <!-- <div id="isMobile">
          <div class="title">{{ item.title }}</div>
          <div class="content">
            <div
              class="list"
              v-for="(itemSon, index) of item.list"
              :key="index"
            >
              <template v-if="index == 0">
                <div class="desc" v-for="itemSun of itemSon" :key="itemSun">
                  {{ itemSun }}
                </div>
                <div class="desc">{{ item.list[1][0] }}</div>
                <div class="desc">{{ item.list[1][1] }}</div>
              </template>
              <template v-else-if="index == 2">
                <div class="desc">{{ item.list[1][2] }}</div>
                <div class="desc">{{ item.list[1][3] }}</div>
                <div class="desc" v-for="itemSun of itemSon" :key="itemSun">
                  {{ itemSun }}
                </div>
              </template>
            </div>
          </div>
        </div> -->
      </div>
      <!-- 产品介绍 -->
      <div class="component5" v-if="item.type == 'component5'">
        <div>
          <div class="title">{{ item.title }}</div>
          <div class="content">
            <img :src="item.img" alt="" />
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
      <Module v-if="item.type == 'Module'" :title="item.title" :list="item.list"></Module>
      <!-- 设备支持 -->
      <Constitute
        v-if="item.type == 'Constitute'"
        :title="item.title"
        :constitute="item.list"
      ></Constitute>
      <Constitute2
        v-if="item.type == 'Constitute2'"
        :title="item.title"
        :constitute="item.list"
        :background='item.background'
      ></Constitute2>
      <EgApplication v-if="item.type == 'eg'" :title="item.title" :list="item.list"></EgApplication>
    </div>
  </div>
</template>
<script>
import Introduce from '@/component/introduce';
import Introduce2 from '@/component/introduce2';
import Introduce3 from '@/component/introduce3';
import Module from '@/component/module';
import Position from '@/component/position';
import Constitute from '@/component/constitute';
import Constitute2 from '@/component/constitute2';
import EgApplication from '@/component/egApplication';

export default {
  components: {
    Introduce,
    Introduce2,
    Introduce3,
    Position,
    Module,
    Constitute,
    Constitute2,
    EgApplication
  },
  data() {
    return {
      list: [2, 3, 1, 4],
      constitute: [
        {
          title: '',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/plan/1.png'
        },
        {
          title: '',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/plan/2.png'
        },
        {
          title: '',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/plan/3.png'
        },
        {
          title: '',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/plan/4.png'
        }
      ],
      data: [
        {
          title: '土木建筑BIM-VR教学系统',
          banner:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/2.jpg',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/1.jpg',
          componentList: [
            {
              type: 'Introduce',
              img:
                'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/dian/10.png',
              desc:
                '土木建筑BIM-VR教学系统是在“新工科”背景下的跨学科融合技术，以真实工程项目为原型，打造真实建设工程虚拟仿真实验教学平台，通过虚实结合、人机互动的操作让学生在课堂就能达到在真实项目工地的实践效果；为教师提供从项目图纸、项目管理资料、项目设计方案、BIM设计模型、虚拟建造过程到工程运维管理，覆盖建设工程全生命周期的一体化虚拟仿真教学及实践解决方案，无缝衔接了课堂教学和工程实践的需求；通过BIM技术建立3D模型,利用VR展现,施工者可在虚拟现实中模拟机房的建造,节省建造成本,提高工程效率。'
            },
            {
              type: 'Module',
              title: '产品组成',
              list: [
                {
                  title: 'BIM全息箱',
                  desc: '集全息、3D、VR等多种技术为一体，是一款便携式多功能的沉浸式VR交互一体机设备，包含VR头显、3D眼镜、高清投影仪、高性能主机工作站等。',
                  img:
                    'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/4.png'
                },
                {
                  title: 'BIM-VR智能建造平台',
                  desc: '利用BIM技术结合游戏级引擎技术，快速制作建设工程BIM动画的3D可视化工具系统。与虚拟现实硬件无缝对接，支持多人协同交互。',
                  img:
                    'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/5.png',
                },
                {
                  title: '土木建筑教学资源',
                  desc: '多项BIM-VR课件资源可通过VR交互式、PC交互式等多种方式展现，覆盖土木建筑学科全部课程知识点。',
                  img:
                    'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/6.png',
                }
              ]
            },
            {
              type: 'Constitute',
              title: '产品优势',
              list: [
                {
                  title: '学习成本低',
                  desc: '初学者可快速制作专业的BIM动画及BIM-VR作品'
                },
                {
                  title: '平台功能强',
                  desc: 'AR/VR/MR/效果图/大屏互动/多屏互动一键生成'
                },
                {
                  title: '数据兼容性强',
                  desc: '支持3DMax/Revit/Bentley/MagiCAD/Tekla/SketchUp等'
                },
                {
                  title: '超大场景VR支持',
                  desc: '成功支撑1800万平的市政项目'
                }
              ]
            },
            {
              type: 'component5',
              title: '产品应用',
              desc:
                '土木建筑BIM-VR教学系统可应用于中职、高职、本科院校的建筑学、BIM、建筑设计、装饰设计、规划设计、景观设计等专业；以及设计院、研究院、房地产商、装饰企业、施工单位等行业。',
              img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/2.jpg'
            },
            {
              type: 'component3',
              title: '课件资源',
              list: [
                [
                  '建筑材料BIM-VR课件资源',
                  '图纸识读BIM-VR课件资源',
                  '施工工艺BIM-VR课件资源',
                  '计量计价 BIM-VR 课件资源',
                  '定额测定BIM-VR课件资源'
                ],
                [
                  '全过程管理BIM-VR课件资源',
                  '招投标管理BIM-VR课件资源',
                  '木作结构古建筑BIM-VR课件资源',
                  '室内装饰工程BIM-VR课件资源',
                  '施工安全隐患BIM-VR课件资源'
                ],
                [
                  '城市规划BIM-VR课件资源',
                  '园林景观规划BIM-VR课件资源',
                  '木构架古建筑构件BIM-VR课件资源',
                  '高层建筑防火BIM-VR课件资源'
                ]
              ]
            }
          ]
        },
        {
          title: '高校虚拟仿真机械教学系统',
          banner:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/8.jpg',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/7.jpg',
          componentList: [
            {
              type: 'Introduce',
              desc:
                '高校虚拟仿真机械教学系统是以培养学生共同协作及动手能力为重点，结合优质的教学内容，硬件终端、应用平台，为高职高校学生创设接近真实的学习环境，将复杂的知识点、昂贵或稀缺的设备立体展现，让师生自由教学。通过多人互动学习，激发学生创造力、学习主动性、培养团队协作精神，促进提升高职高校的教学效果。'
            },
            {
              type: 'Module',
              title: '产品组成',
              list: [
                {
                  title: '硬件体系',
                  desc: '通过MR头显、手柄、iPad、三脚架等设备，为MR互动教学提供了完备的硬件支持。',
                  img:
                    'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/9.png'
                },
                {
                  title: '教学平台',
                  desc: '包含教师端、学生端，可集中管理课程内容，并提供课程管理系统，对3D模型等资源进行集中增删改查等。',
                  img:
                    'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/11.png',
                },
                {
                  title: '课程资源',
                  desc: '拥有液压与气压、机械设计、矿山机械、机械工训四大方向高精度三维可拆解模型，全覆盖机械类产品使用。',
                  img:
                    'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/10.png',
                }
              ]
            },
            {
              type: 'Constitute2',
              title: '产品优势',
              list: [
                [
                  {
                    title: '课件丰富',
                    desc: '实际教学中因为成本昂贵、元件绝版等原因缺失的课程，都可以通过MR机械来完成'
                  },
                  {
                    title: '零距离零事故',
                    desc: '避免直接接触危险性高的实操课程以保证安全'
                  }
                ],
                [
                  {
                    title: '灵活方便',
                    desc: '随时随地，无需特意去现场，省时省力'
                  },
                  {
                    title: '成本低效率高',
                    desc: '无需造价昂贵的实物机械，纯虚拟机械模型，可反复操作练习'
                  }
                ],
                [
                  {
                    title: '全新授课模式',
                    desc: '顶尖科技+教学，多维的学习体验，加深记忆力'
                  },
                  {
                    title: '更多实操机会',
                    desc: '多人同时可独立或协作参与机械拆分'
                  }
                ]
              ]
            },
            {
              type: 'eg',
              title: '产品应用',
              list: [{
                title: '与中山大学达成合作',
                desc: '中山大学利用MR产品开始了一系列科研活动，大幅提升了科研创新能力',
                img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/28.jpg'
              },
              {
                title: '与深圳大学MR制作教学系统项目达成合作',
                desc: '深圳大学利用MR产品研究新的课题方向，颠覆式的改革课堂教学方式',
                img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/29.jpg'
              },
              {
                title: '格如灵与广东工贸MR实训中心项目达成合作',
                desc: '广东工贸职业技术学院是一所拥有国家级的虚拟仿真教学师资培训基地的公办高职学校，与格如灵强强联合，共同建设了混合现实MR实训中心。为学校教学、研究提供了强大的科技力量支撑，并与格如灵达成了长期技术交流战略合作',
                img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/30.jpg'
              }]
            }
          ]
        },
        {
          title: '汽修专业教学系统',
          banner:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/20.jpg',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/21.jpg',
          componentList: [
            {
              type: 'Introduce',
              img:
                'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/dian/10.png',
              desc:
                '集汽车发动机，底盘，电气，车身各系统结构、原理、拆装、检测、维护与故障排除的教学、实训、考核、备课、授课于一体，并容纳多种车型、可交互操作的实训仿真教学资源平台，应用三维仿真技术培养汽车维修技能人才的教学软件。'
            },
            {
              type: 'Introduce2',
              title: '课程内容',
              desc: '涵盖了汽车发动机构造与维修，汽车机械基础，汽车底盘构造与维修，汽车电器设备与维修，整车维护，汽车机械识图，汽车空调，汽车营销，汽车维修业务接待，汽车使用常识，汽车材料，汽车性能检测，车身修复，汽车涂装，汽车文化，汽车电工电子，汽车故障诊断与排除，汽车结构认识所需教学实训仿真资源。',
              img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/22.jpeg',
              img2: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/23.jpeg'
            },
            {
              type: 'Constitute',
              title: '教学特点',
              list: [
                {
                  title: '',
                  desc: '实现工具箱的上传功能，以保证不同学校对工具要求的不同，实训提供完整的实训报告。'
                },
                {
                  title: '',
                  desc: '保证老师对各学生的实训操作过程的留档备份仿真实训提供步骤提示功能。'
                },
                {
                  title: '',
                  desc: '独具特色的故障设置与检测，在电路故障中可以任意对电路中任意器件与连接线束进行故障设置，以满足故障排除的任意性与多样性。'
                }
              ]
            },
          ]
        },
        {
          title: '商科教学系统',
          banner:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/12.jpg',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/13.jpg',
          componentList: [
            {
              type: 'Introduce',
              img:
                'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/dian/10.png',
              desc:
                '商科教学系统是基于生产制造企业“人财物产供销”全场景要素，以教学逻辑抽取企业核心岗位与业务情境，结合AR台智能感知设备，打造的3D实境化企业经营管理教学系统。基于“场景实境化、情境任务化、全局可视化”的设计理念，应用XR技术搭建实境仿真企业全场景，将企业经营和管理的核心要素等抽像的知识具象化，开创“场景化情境式”教学和“人机感知交互”教学新模式。通过将课程内容、学习角色、教学评价机制等全方位职业化，培养学生对企业、工业和商业的全局观，缩短未来工作岗位适应期。'
            },
            {
              type: 'Module',
              title: '产品优势',
              list: [
                {
                  title: '源于真实场景',
                  desc: '通过XR技术构建企业场景，将二维的全局知识和逻辑与三维的微观场景紧密结合，实现经营数据、业务信息的动态实时变化；通过人机交互学习方式，营造全脑学习条件。',
                  img:
                    'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/14.png'
                },
                {
                  title: '还原真实情境',
                  desc: '将企业经营场景进行情境切片，构建销售接单、生产计划、生产备料、生产执行、销售发货、开票结算等十二大情境活动，学生可跨越时间与空间的界限探究企业经营全过程。',
                  img:
                    'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/15.png',
                },
                {
                  title: '模拟真实岗位',
                  desc: '设计CEO、采购、财务、销售、生产、仓储和品管七大关键岗位，引入真实工作内容，通过手机或PAD与虚拟场景中的人物、单据进行扫码交互，顶岗实训。',
                  img:
                    'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/16.png',
                },
                {
                  title: '训练真实能力',
                  desc: '结合增强现实场景的观察、思考，现实环境的角色体验、实践，通过 “场景连接角色与内容”的混合模式，训练学生知企业、懂管理、熟业务、会经营、善思考的职业能力。',
                  img:
                    'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/17.png',
                }
              ]
            },
            {
              type: 'Constitute',
              title: '产品组成',
              list: [
                {
                  title: '实境感知教学系统',
                  desc: '由上屏显示单元与下屏交互单元组成，涵盖3D实境场景、实境交互系统、经营全局画布。'
                },
                {
                  title: '商科教学平台',
                  desc: '教师端设计有课程管理、班级管理、学生管理、教学管理、成绩管理，以及企业实境系统数据配置管理；学生端设计有学习中心、课程中心、绩效中心、工作中心等。'
                },
                {
                  title: '课程内容',
                  desc: '包含企业经营场景情境活动、企业经营管理核心岗位角色及多个虚拟人物、3D可视化现代化工厂。'
                }
              ]
            },
            {
              type: 'component5',
              title: '产品应用',
              desc:
                '格如灵商科教学系统可应用于中职、高职、本科院校，帮助院校建设企业仿真教学环境，建立产供销一体化协同模式下的企业运营管理及相关课程，满足院校企业认知实习、企业经营实训、企业运营实验、供应链管理实训、创新创业基础等教学需求。',
              img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/12.jpg'
            }
          ]
        },
        {
          title: '室内设计教学系统',
          banner:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/18.jpg',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/19.jpg',
          componentList: [
            {
              type: 'Introduce',
              img:
                'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/dian/10.png',
              desc:
                '室内设计教学系统是一款围绕室内设计课程教育教学的全新三维家装设计PC端教学平台软件。平台软件集成了海量的三维素材库，全中文的操作界面，具备快速设计效果输出、快速效果展示、沉浸式+远程互动式交流体。学生可以快速搭建三维环境空间设计作品，在全沉浸式的虚拟现实环境中体验设计成果；教师可以从海量精品案例库中调用设计案例，为学生快速、全沉浸式的展示教学案例，达到寓教于乐的教学效果。'
            },
            {
              type: 'Module',
              title: '功能介绍',
              list: [
                {
                  title: '界面操作',
                  desc: '包含一键发布、后期色彩校正、均布与对齐、创建灯光',
                  img:
                    'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/24.png'
                },
                {
                  title: '通用编辑器',
                  desc: '包含导入、导出、点光源创建、创建线型、加载线型、线型入库等功能',
                  img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/25.png'
                },
                {
                  title: '海量资源库',
                  desc: '包含家装产品库、材质库、线型库、户型库、天空环境库、地板拼接库',
                  img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/26.png'
                },
                {
                  title: '资源入库',
                  desc: '包含家装产品入库、材质入库、户型入库、线型入库、外景天空资源入库',
                  img:
                    'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/27.png',
                }
              ]
            },
            {
              type: 'Constitute',
              title: '产品优势',
              list: [
                {
                  title: '急速出图',
                  desc: '海量资源，10秒渲4K出图，1分钟全屋烘培，无需网络、无需收费'
                },
                {
                  title: 'VR直通',
                  desc: 'HTC VIVE等头盔即插即用，一键VR展示全屋设计成果，可行走、可交互'
                },
                {
                  title: '一站式设计展示',
                  desc: '包含设计、定制家具、CAD施工图、渲染图、VR发布等功能'
                },
                {
                  title: '可视化编辑界面',
                  desc: '界面编辑过程中，尺寸、材质、光照实时呈现，设计师方案一键布局'
                }
              ]
            },
            {
              type: 'component5',
              title: '产品应用',
              desc:
                '室内设计虚拟现实设计工具平台是一款基于场景的教学工具，服务于广大泛建筑设计学校与机构，涵盖建筑设计、园林景观、环境艺术、室内家装、城市规划等领域。',
              img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product_detail/18.jpg'
            }
          ]
        }
      ],
      indexId: 0,
      nowData: {
        componentList: []
      },
      background: '#AE1303',
      isMobile: false
    };
  },
  created() {
    this.indexId = this.$route.query.id;
    // 默认配图
    this.data.forEach((item, index) => {
      if (item.componentList) {
        item.componentList.forEach(itemSon => {
          if (itemSon.type === 'Constitute') {
            itemSon.list.forEach((itemGrandson, indexSon) => {
              itemGrandson.img = this.constitute[indexSon].img;
            });
          }
        });
      }
    });
    this.nowData = this.data[this.indexId];
    if (document.body.clientWidth < 1000) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  watch: {
    $route(to, from) {
      if (from.name === to.name) {
        this.indexId = this.$route.query.id;
        this.nowData = this.data[this.indexId];
      }
    }
  }
};
</script>
<style lang="less" scoped>
.main {
  .banner {
    width: 100%;
    height: 500px;
    display: block;
  }
  .component1 {
    width: 100%;
    padding-bottom: 60px;
    background: #fff;
    > div {
      width: 1200px;
      margin: 0 auto;
      .title {
        text-align: center;
        font-size: 42px;
        padding-top: 60px;
        color: rgba(0, 0, 0, 0.6);
        font-weight: 500;
      }
      .content {
        width: 100%;
        display: flex;
        margin-top: 33px;
        .list {
          width: 25%;
          flex: 1;
          padding: 0 30px;
          padding-top: 35px;
          box-sizing: border-box;
          min-height: 187px;
          border-right: 1px solid #cdcaca;
          &:last-child {
            border-right: none;
          }
          .headline {
            font-size: 28px;
            color: #807c7c;
            text-align: center;
          }
          .desc {
            font-size: 22px;
            color: #807c7c;
            line-height: 34px;
            margin: 0 auto;
            margin-top: 16px;
            text-align: justify;
            max-width: 266px;
          }
        }
      }
    }
  }
  .component2 {
    width: 100%;
    padding-bottom: 90px;
    background: #fff;
    > div {
      width: 1200px;
      margin: 0 auto;
      .title {
        text-align: center;
        font-size: 42px;
        padding-top: 53px;
        color: rgba(0, 0, 0, 0.6);
        font-weight: 500;
      }
      .content {
        width: 100%;
        display: flex;
        margin-top: 62px;
        .list {
          width: 50%;
          padding: 0 30px;
          padding-top: 35px;
          box-sizing: border-box;
          min-height: 152px;
          border-right: 1px solid #7b7a7a;
          &:last-child {
            border-right: none;
          }
          .headline {
            display: flex;
            align-items: center;
            img {
              width: 36px;
              margin-right: 16px;
            }
            span {
              font-size: 28px;
              color: #807c7c;
            }
          }
          .desc {
            margin-top: 16px;
            div {
              font-size: 18px;
              color: #807c7c;
              line-height: 34px;
              margin-top: 4px;
            }
          }
        }
      }
    }
  }
  .component3 {
    width: 100%;
    padding-bottom: 60px;
    > div {
      width: 1200px;
      margin: 0 auto;
      .title {
        text-align: center;
        font-size: 42px;
        padding-top: 53px;
        color: rgba(0, 0, 0, 0.6);
        font-weight: 500;
      }
      .content {
        width: 100%;
        display: flex;
        margin-top: 22px;
        .list {
          width: 33.3%;
          min-height: 200px;
          border-right: 1px solid #7b7a7a;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          &:last-child {
            border-right: none;
          }
          .desc {
            color: #807c7c;
            font-size: 22px;
            line-height: 38px;
          }
        }
      }
    }
  }
  .component4 {
    width: 100%;
    padding-bottom: 60px;
    background: #fff;
    > div {
      width: 1200px;
      margin: 0 auto;
      .title {
        text-align: center;
        font-size: 42px;
        padding-top: 60px;
        color: rgba(0, 0, 0, 0.6);
        font-weight: 500;
      }
      .content {
        width: 100%;
        display: flex;
        margin-top: 60px;
        .list {
          width: 50%;
          padding: 0 30px;
          box-sizing: border-box;
          min-height: 152px;
          padding-bottom: 20px;
          border-right: 1px solid #7b7a7a;
          &:last-child {
            border-right: none;
          }
          .headline {
            font-size: 28px;
            color: #807c7c;
          }
          .desc {
            font-size: 18px;
            color: #807c7c;
            line-height: 34px;
            margin-top: 28px;
          }
        }
      }
    }
  }
  .component5 {
    width: 100%;
    padding-bottom: 60px;
    background: #fff;
    > div {
      width: 1200px;
      margin: 0 auto;
      .title {
        text-align: center;
        font-size: 42px;
        padding-top: 60px;
        color: rgba(0, 0, 0, 0.6);
        font-weight: 500;
      }
      .content {
        img {
          width: 100%;
          height: 290px;
          display: block;
          margin-top: 50px;
        }
        .desc {
          font-size: 22px;
          color: rgba(0, 0, 0, 0.6);
          line-height: 40px;
          margin-top: 30px;
          text-align: justify;
        }
      }
    }
  }
}
@media (max-width: 1000px) {
  .main{
    .banner{
      height: 348px;
    }
    .component1{
      padding: 0;
      > div{
        width: 100%;
        padding-top: 1px;
        .title{
          font-size: 44px;
          color: #5E5E5E;
          letter-spacing: 0;
          text-align: center;
          font-weight: 600;
          padding-top: 80px;
        }
        .content{
          flex-wrap: wrap;
          padding: 0 48px;
          justify-content: space-between;
          margin-top: 80px;
          .list{
            width: 320px;
            flex: none;
            margin-bottom: 100px;
            border: none;
            padding: 0 10px;
            .headline{
              font-size: 36px;
              color: #5E5E5E;
              letter-spacing: 0;
              text-align: center;
              line-height: 44px;
              font-weight: 400;
            }
            .desc{
              font-size: 28px;
              color: #5E5E5E;
              letter-spacing: 0;
              text-align: justify;
              line-height: 40px;
              font-weight: 400;
              margin-top: 20px;
              max-width: 100%;
            }
          }
        }
      }
    }
    .component2{
      > div{
        width: 100%;
        padding: 0 48px;
        .title{
          font-size: 44px;
          color: #5E5E5E;
          letter-spacing: 0;
          text-align: center;
          font-weight: 600;
          padding-top: 80px;
        }
        .content{
          margin-top: 80px;
          display: block;
          .list{
            width: 100%;
            border: none;
            padding: 0;
            .headline{
              margin-top: 80px;
              margin-bottom: 40px;
              img{
                width: 48px;
              }
              span{
                font-size: 36px;
                color: #5E5E5E;
                letter-spacing: 0;
                line-height: 44px;
                font-weight: 400;
              }
            }
            .desc{
              margin-top: 20px;
              div{
                font-size: 28px;
                color: #5E5E5E;
                letter-spacing: 0;
                text-align: justify;
                line-height: 40px;
                font-weight: 400;
                margin-top: 20px;
              }
            }
          }
        }
      }
    }
    .component1Three{
      > div{
        .content{
          .list{
            width: 100%;
            .headline{
              font-size: 36px;
              color: #5E5E5E;
              letter-spacing: 0;
              line-height: 44px;
              font-weight: 400;
            }
            .desc{
              font-size: 32px;
              color: #5E5E5E;
              letter-spacing: 0;
              text-align: justify;
              line-height: 48px;
              font-weight: 400;
              margin-top: 20px;
              width: 550px;
              max-width: 550px;
            }
          }
        }
      }
    }
    .component3{
      > div{
        width: 100%;
        .title{
          font-size: 44px;
          color: #5E5E5E;
          letter-spacing: 0;
          text-align: center;
          font-weight: 500;
          padding-top: 80px;
        }
        .content{
          display: block;
          overflow: hidden;
          .list{
            width: 100%;
            position: relative;
            border: none;
            padding: 40px;
            .desc{
              font-size: 32px;
              color: #5E5E5E;
              letter-spacing: 0;
              text-align: center;
              line-height: 52px;
              font-weight: 400;
            }
            &::after{
              content: '';
              position: absolute;
              bottom: -2px;
              left: 50%;
              margin-left: -50px;
              width: 100px;
              height: 2px;
              background: #F8BA1D;
            }
          }
        }
      }
    }
    // .component3{
    //   background: #fff;
    //   padding-top: 1px;
    //   > div{
    //     width: 100%;
    //     .title{
    //       font-size: 44px;
    //       color: #5E5E5E;
    //       letter-spacing: 0;
    //       text-align: center;
    //       font-weight: 500;
    //       padding-top: 80px;
    //     }
    //     .content{
    //       justify-content: space-between;
    //       padding: 0 48px;
    //       margin-top: 80px;
    //       .list{
    //         width: 50%;
    //         border-right: 1px solid #EBEBEB;
    //         .desc{
    //           font-size: 32px;
    //           color: #5E5E5E;
    //           letter-spacing: 0;
    //           text-align: center;
    //           line-height: 52px;
    //           font-weight: 400;
    //         }
    //       }
    //       .list:nth-child(2){
    //         display: none;
    //       }
    //     }
    //   }
    // }
    .component4{
      > div{
        width: 100%;
        .title{
          font-size: 44px;
          color: #5E5E5E;
          letter-spacing: 0;
          text-align: center;
          font-weight: 500;
          padding-top: 80px;
        }
        .content{
          margin-top: 80px;
          .list{
            border: none;
            .headline{
              font-size: 36px;
              color: #5E5E5E;
              letter-spacing: 0;
              text-align: center;
              line-height: 44px;
              font-weight: 400;
              text-align: center;
            }
            .desc{
              font-size: 28px;
              color: #5E5E5E;
              letter-spacing: 0;
              text-align: justify;
              line-height: 40px;
              font-weight: 400;
              margin: 0 auto;
              margin-top: 20px;
              width: 280px;
            }
          }
        }
      }
    }
    .component5{
      padding-bottom: 80px;
      > div{
        width: 100%;
        .title{
          font-size: 44px;
          color: #5E5E5E;
          letter-spacing: 0;
          text-align: center;
          font-weight: 500;
          padding-top: 80px;
        }
        .content{
          padding: 0 48px;
          margin-top: 80px;
          img{
            width: 100%;
            height: 160px;
          }
          .desc{
            margin-top: 40px;
            font-size: 28px;
            color: #5E5E5E;
            letter-spacing: 0;
            text-align: justify;
            line-height: 40px;
            font-weight: 400;
          }
        }
      }
    }
  }
}
</style>
